import Questions from 'components/Footer/Questions';
import * as React from 'react';
export default {
  Questions,
  React
};